import EbzModal from './EbzModal';

export default EbzModal;
